import {UpdateUserBody} from '../../../interfaces/api/auth/login';
import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';
import {services} from '../../../api';
import {startSession, updateConfig} from '../../auth/login/actions';
import {showGlobalToast} from '../../../connected-components/toast/actions';
import {tr} from '../../../translations';
import {store} from '../../../redux/store';
import {resetTabsVoice} from '../settings/reducer';
import {ToastType} from '../../../utils/enums';
import {getHomeTabs} from '../home/actions';

/**
 * this function to Update User details
 */
export const updateUser = async (body: UpdateUserBody,withoutLoading?:boolean): Promise<boolean> => {
  try {
    if(!withoutLoading){
      startLoading();
    }
    const {currentUser} = store.getState().auth || {};
    const res = await services.auth.updateUser(body);
    if(!withoutLoading){
    showGlobalToast({
      message: tr('profile.profileUpdateSuccess'),
      type: ToastType.HELP,
    });
  }
    const tempRes = {...(res?.content || {})};

    if (!!tempRes?.voice_url && currentUser?.voice_url !== tempRes?.voice_url) {
      store.dispatch(resetTabsVoice());
    }

    const tempCurrentUser = {
      ...(currentUser || {}),
      ...(tempRes || {}),
      //@ts-ignore
      token: currentUser?.token || tempRes?.token || '',
    };

    await startSession(tempCurrentUser);
    getHomeTabs();
    updateConfig();
    return true;
  } catch (error: any) {
    return false;
  } finally {
    finishLoading();
  }
};
